import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulated.correction.finishConfirmation.title',
    defaultMessage: 'FINISH',
  },
  subtitle: {
    id: 'simulated.correction.finishConfirmation.subtitle',
    defaultMessage:
      'By clicking "Accept", you will be ending this step. If it becomes necessary to load more answer cards later, remember to finish the step again by clicking "Finished and report Requested".',
  },
  cancel: {
    id: 'simulated.correction.finishConfirmation.cancel',
    defaultMessage: 'Cancel',
  },
  accept: {
    id: 'simulated.correction.finishConfirmation.accept',
    defaultMessage: 'Accept',
  },
});
